export class Logger {
  private enabled: boolean;

  constructor(enabled: boolean = false) {
    this.enabled = enabled;
  }

  log(message: string, content: any = ""): void {
    if (this.enabled) {
      console.log(
        `%c[📢 RetailhubEvents] ${message}`,
        "background: #340082ff; color: #ffffffff; padding:2px 4px; border-radius:2px;",
        content
      );
    }
  }

  enable(): void {
    this.enabled = true;
  }

  disable(): void {
    this.enabled = false;
  }

  isEnabled(): boolean {
    return this.enabled;
  }
}
